export default "__VITE_ASSET__COr72W3k__"